import { i18n } from '@/i18n';
import { getStore } from '@/store';
import { DropdownOption } from './DropdownApi';

export const loadForm = (formId) => getStore().dispatch('loadForm', formId);

/** This is to test if translation keys look like eg. 'tenant.2', in which case we do not want to translate them */
function isValidTranslationKey(key) {
  return typeof key !== 'string' || !/\.\d+$/.test(key);
}

function translateIfExists(key: string, locale: string, defaultValue: string): string {
  return (isValidTranslationKey(key) && i18n.te(key, locale)) ? (i18n.t(key, locale) as string) : defaultValue;
}

export const getDropdownOptions = (dropdownId: string | string[], locale: string, params?: any) => {
  let dropdownPromise;
  if (!Array.isArray(dropdownId)) {
    dropdownPromise = getStore().dispatch('loadDropdown', {
      id: dropdownId,
      languageId: locale,
      refresh: false,
      params,
    });
  } else {
    dropdownPromise = Promise.all(dropdownId.map((id) => getStore().dispatch('loadDropdown', {
      id,
      languageId: locale,
      refresh: false,
      params,
    })))
      .then((dropdownOptions) => [].concat(...dropdownOptions));
  }
  return dropdownPromise
    .then((dropdownOptions) => dropdownOptions.map((option) => ({
      id: option.id,
      text: translateIfExists(option.id, locale, option.text),
      properties: option.properties,
    })));
};

/**
 * Translates dropdown/{}/option
 * because we other method translates dropdown/{}/value
 * */
export function translateOption(option: DropdownOption, locale: string) {
  return {
    id: option.id,
    text: translateIfExists(option.id, locale, option.defaultText || option.id),
    properties: option.properties,
  };
}

export const getDropdownValue = (dropdownId, languageId, value) => getDropdownOptions(dropdownId, languageId).then((dropdownVals) => {
  if (value) {
    if (Array.isArray(value)) {
      let ret = '';
      value.forEach((val) => {
        const opt = dropdownVals.find((element) => element.id === val);
        const txt = opt ? opt.text : val;
        if (ret.length > 0) { ret = `${ret},${txt}`; } else { ret = txt; }
      });
      return ret;
    }
    const option = dropdownVals.find((element) => element.id === value);
    return option ? option.text : value;
  }
  return value;
});

export const refreshDropdown = (dropdownId, locale) => getStore().dispatch('loadDropdown', {
  id: dropdownId,
  languageId: locale,
  refresh: true,
});
